var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUkraine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_284_100822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.938 1.55172C22.3139 1.55219 22.6743 1.68544 22.9401 1.92223C23.2059 2.15902 23.3555 2.48005 23.356 2.81493V20.521C23.3555 20.8559 23.2059 21.1769 22.9401 21.4137C22.6743 21.6505 22.3139 21.7838 21.938 21.7843H2.06201C1.6861 21.7838 1.32572 21.6505 1.05991 21.4137C0.7941 21.1769 0.644523 20.8559 0.643994 20.521V2.81493C0.644523 2.48005 0.7941 2.15902 1.05991 1.92223C1.32572 1.68544 1.6861 1.55219 2.06201 1.55172H21.938ZM21.938 0.978027H2.06201C1.5153 0.978499 0.991126 1.17219 0.604541 1.51657C0.217956 1.86095 0.000529505 2.3279 0 2.81493V20.521C0.000529505 21.0081 0.217956 21.475 0.604541 21.8194C0.991126 22.1638 1.5153 22.3575 2.06201 22.3579H21.938C22.4845 22.357 23.0084 22.1632 23.3949 21.8189C23.7813 21.4746 23.9989 21.0079 24 20.521V2.81493C23.9995 2.3279 23.782 1.86095 23.3955 1.51657C23.0089 1.17219 22.4847 0.978499 21.938 0.978027Z",
    fill: "#CAB99E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9379 1.55176H2.06197C1.68605 1.55223 1.32568 1.68548 1.05987 1.92227C0.794057 2.15906 0.644481 2.48009 0.643951 2.81497V11.668H23.356V2.81497C23.3554 2.48009 23.2059 2.15906 22.94 1.92227C22.6742 1.68548 22.3139 1.55223 21.9379 1.55176Z",
    fill: "#0055A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.643951 20.521C0.644481 20.8559 0.794057 21.1769 1.05987 21.4137C1.32568 21.6505 1.68605 21.7838 2.06197 21.7842H21.9379C22.3139 21.7838 22.6742 21.6505 22.94 21.4137C23.2059 21.1769 23.3554 20.8559 23.356 20.521V11.668H0.643951V20.521Z",
    fill: "#FFD000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_284_100822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21.3799,
    fill: "white",
    transform: "translate(0 0.978027)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkraine);
export default __webpack_public_path__ + "static/media/Ukraine.c2c9bc46eb94b25d5b0048c62b44c129.svg";
export { ForwardRef as ReactComponent };